import React, {Component} from "react";
import {Col, Container, Row, Image} from "react-bootstrap";
import CopyRight from "../Legal/CopyRight";
import TOS from "../Legal/TOS";
import PrivacyPolicy from "../Legal/PrivacyPolicy";
import "./AppPageWrapper.css"
import ConnectedNavMenu from "./NavMenu";
import {AppNotice} from "../AppNotice/AppNotice";
import MouseDetectionLogoutTimer from "../MouseDetectionLogoutTimer";
import {SupportedBrowsers} from "./SupportedBrowsers";
import logoImage from "../../assets/images/logo.png";
import {ApiHostName} from "../../api/ApiUrl";
import EmailSupport from "../Legal/EmailSupport"
import { GetSSOToken } from "../../storage/AuthToken";

export interface AppPageWrapperProps{
  parentClassName?: string
  showNav?: boolean
  showSupportedBrowsers?: boolean
  hideLogo?: boolean
  embedingMode?: boolean
}
export class AppPageWrapper extends Component<AppPageWrapperProps> {

  render() {
    const logoSrc = getPortalLogoImageSrc();
    const ssoToken = GetSSOToken()
    const embedingMode = ssoToken !== "" || !!this.props.embedingMode
    if (!embedingMode) {
      return <div id="app-root" className={'bg-white' || this.props.parentClassName || ''} >
            { (this.props.hideLogo !== true) &&
          <div id="portal-logo-container">
                <img id="portal-logo-image"  src={logoSrc}  />
          </div>
        }
        <MouseDetectionLogoutTimer>
          <>
            {this.props.showNav && (<>
              <ConnectedNavMenu />
              <Container fluid={true} >
                <div className="m-2">
                                {this.props.children }
                </div>
              </Container>
            </>)}
            <Container fluid={true}>
                      {!this.props.showNav && <>{this.props.children }</> }
              <hr />
              <Row>
                        <Col lg={{span: 4, order: 2} }>
                  <div className="text-center">
                    <strong><CopyRight /></strong>
                  </div>
                </Col>
                        <Col lg={{span: 4, order: 3}} className="text-right">
                  <EmailSupport />{' | '}<TOS />{' | '}<PrivacyPolicy />
                </Col>
                        <Col lg={{span: 4, order: 1} }>
                          {!!this.props.showSupportedBrowsers && <SupportedBrowsers /> }
                </Col>
              </Row>
            </Container>
          </>
          <AppNotice />
        </MouseDetectionLogoutTimer>
      </div>
    }
    return  <div id="app-root" className={'bg-white' || this.props.parentClassName || ''} >
       <MouseDetectionLogoutTimer>
          <>
            {this.props.showNav && (<>
              <Container fluid={true} >
                <div className="m-2">
                  {this.props.children}
                </div>
              </Container>
            </>)}
          </>
          <AppNotice />
        </MouseDetectionLogoutTimer>
    </div>
  }
}
function getPortalLogoImageSrc(): string {

  const portalImage = localStorage.getItem("portalImage");
    if(!portalImage){
    const defaultSrc = logoImage;
    return defaultSrc;
  }
  const result = 'data:image/png;base64, ' + encodeURI(portalImage);
  return result;
}
